var map = {
	"./brandIcon.svg": "fa9d",
	"./chevronIcon.svg": "b38a",
	"./clipboardIcon.svg": "e648",
	"./closeIcon.svg": "ceb4",
	"./defaultAssetIcon.svg": "697b",
	"./errorIcon.svg": "e0b1",
	"./externalLinkIcon.svg": "f27e",
	"./infoIcon.svg": "9efc",
	"./moonIcon.svg": "c61a",
	"./pendingIcon.svg": "61c4",
	"./settingsIcon.svg": "4b81",
	"./successIcon.svg": "9c5e",
	"./sunIcon.svg": "d4aa",
	"./triangleIcon.svg": "4e01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a49b";